import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import './styles.css'

const DaySelectorItem = (props) => {
  const { data, handleClick, className } = props

  const dayOfWeek = data.format('ddd')
  const date = data.format('MMM Do')
  const dayDisabled = moment().isBefore(data)

  return (
    <button
      className={`daySelectorListItem ${className} ${dayDisabled ? 'disabled' : ''}`}
      onClick={() => handleClick(data)}
      value={data}
      disabled={dayDisabled}
    >
      {dayOfWeek}<br />{date}
    </button>
  )
}

DaySelectorItem.propTypes = {
  data: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default DaySelectorItem



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/DaySelectorItem.js